import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { JwtPayload } from "jwt-decode";

import "./App.css";
import Routers from "./router/routes";
import { RootState } from "./redux/app/store";
import { UserRole, validateToken } from "./utils/general";
import { storeToken } from "./redux/features/authentication/signIn";
import { RoleContext } from "./context/RoleContext";

interface MyJwtPayload extends JwtPayload {
  role: UserRole;
}

const App: React.FC = () => {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.signedIn.token);

  useEffect(() => {
    if (token) {
      dispatch(storeToken(token));
    }
  }, [dispatch]);

  const role = React.useMemo<UserRole | null>(() => {
    if (!token) return null;
    const payload = validateToken(token) as MyJwtPayload;

    const isValid = payload.exp ? Date.now() < payload.exp * 1000 : false;
    return isValid ? payload.role : null;
  }, [token]);

  return (
    <div className="App">
      <RoleContext.Provider value={role}>
        <BrowserRouter>
          <Routers role={role} />
        </BrowserRouter>
      </RoleContext.Provider>
    </div>
  );
};

export default App;
